/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreditCardSummary {
  creditCardFlagId?: number;
  creditCardFlagName?: string;
  creditCardId?: number;
  dateCreated?: Date;
  expMonth?: number;
  expYear?: number;
  firstDigits?: string;
  glamId?: string;
  lastDigits?: string;
  nameOnCard?: string;
  personId?: number;
  recurrence?: string;
  recurrenceStatusId?: number;
  subscriberId?: number;
}
